export const eventCategories = [
  "全部",
  "画面中断",
  "主播违规",
  "消费纠纷",
  "内容违规",
  "版权争议",
];

export const eventStatuses = ["全部状态", "受理中", "核查中", "已处理", "已驳回"];

export const events = [
  {
    id: "ev-2026-0824-01",
    title: "星野直播《深夜游戏夜话》连续三次画面中断",
    category: "画面中断",
    status: "已处理",
    date: "2026-08-24",
    updatedAt: "2026-08-29",
    platform: "星野直播",
    room: "深夜游戏夜话",
    reports: 342,
    views: 12860,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20minimal%20editorial%20illustration%20of%20a%20broadcast%20signal%20interruption%2C%20warm%20vermilion%20and%20cream%20paper%20tones%2C%20geometric%20broken%20waveforms%2C%20subtle%20grain%20texture%2C%20no%20text&width=1200&height=800&seq=ev-cover-01&orientation=landscape",
    tags: ["画面中断", "恢复延迟", "付费顺延"],
    summary:
      "8 月 24 日晚间直播期间，直播间在 22 分钟内连续三次出现黑屏中断，单次最长中断约 6 分钟。中断时段互动区消息出现回滚，多名观众提交画面中断反馈，平台随即介入核查。",
    focus: [
      "中断期间是否向观众作出有效告知",
      "中断时段产生的打赏与付费内容如何处理",
      "恢复后直播时长是否顺延补足",
    ],
    timeline: [
      {
        time: "08-24 21:16",
        title: "首次画面中断",
        desc: "直播间画面黑屏，音频同步中断，持续约 2 分钟后恢复。",
      },
      {
        time: "08-24 21:24",
        title: "第二次中断并出现消息回滚",
        desc: "恢复后互动区约 90 秒内的消息丢失，观众提交反馈量快速上升。",
      },
      {
        time: "08-24 21:38",
        title: "第三次中断，长达 6 分钟",
        desc: "主播未在恢复后对中断原因作出说明，付费直播环节被中断。",
      },
      {
        time: "08-25 10:02",
        title: "平台受理并生成受理编号",
        desc: "共收到 342 条画面中断反馈，平台调取推流日志与中断记录。",
      },
      {
        time: "08-29 15:40",
        title: "核查结束，结果同步并公示",
        desc: "认定中断由推流服务切换异常导致，平台方承担主要责任。",
      },
    ],
    resultType: "警告并整改",
    result:
      "核查认定本次连续中断源于推流服务切换配置异常，平台方未在中断期间向观众作出有效告知。平台责令整改并给予警告，要求对中断时段产生的付费内容予以顺延补足，同时优化中断告警机制，后续同类问题需在 60 秒内向观众展示状态提示。",
    related: ["ev-2026-0819-05", "ev-2026-0806-04"],
  },
  {
    id: "ev-2026-0819-02",
    title: "主播“阿洛不熬夜”直播中多次引导私下交易",
    category: "主播违规",
    status: "已处理",
    date: "2026-08-19",
    updatedAt: "2026-08-26",
    platform: "星河直播",
    room: "阿洛的深夜杂谈",
    reports: 208,
    views: 9730,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20chat%20bubble%20crossed%20out%2C%20warm%20amber%20and%20cream%20paper%20tones%2C%20minimal%20geometric%20composition%2C%20subtle%20texture%2C%20no%20text&width=1200&height=800&seq=ev-cover-02&orientation=landscape",
    tags: ["私下交易", "多次违规", "消费风险"],
    summary:
      "多名观众投诉称，主播在直播过程中反复以“私信下单更便宜”为由引导观众脱离平台完成交易。投诉材料包含录屏片段与聊天记录，指向同一行为模式且存在多次重复。",
    focus: [
      "引导脱离平台交易是否属于违规行为",
      "是否存在重复违规与规避监测的情形",
      "受影响的消费者如何追回款项",
    ],
    timeline: [
      {
        time: "08-19 20:30",
        title: "观众集中提交投诉",
        desc: "单场直播中收到 208 条投诉，多数附带录屏时间段。",
      },
      {
        time: "08-20 09:15",
        title: "平台受理并固定证据",
        desc: "调取近 30 天直播回放，识别出 7 次同类引导话术。",
      },
      {
        time: "08-22 14:00",
        title: "主播提交申诉说明",
        desc: "主播主张为粉丝福利，平台要求补充交易凭证。",
      },
      {
        time: "08-26 11:20",
        title: "核查结束并公示处理结果",
        desc: "认定构成引导私下交易，且存在重复违规情形。",
      },
    ],
    resultType: "限制开播 7 天",
    result:
      "核查认定主播存在多次引导观众脱离平台交易的行为，违反平台交易规范。处理结果为限制直播权限 7 天、下架相关回放并扣除违规积分，同时要求主播对已产生的未履约订单协助退款。公示期内主播未提交新的反证材料，处理结果生效。",
    related: ["ev-2026-0806-04", "ev-2026-0730-06"],
  },
  {
    id: "ev-2026-0812-03",
    title: "“山城小馆”直播间出现违规营销话术",
    category: "内容违规",
    status: "核查中",
    date: "2026-08-12",
    updatedAt: "2026-08-27",
    platform: "晨光直播",
    room: "山城小馆·夜宵专场",
    reports: 156,
    views: 7420,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20microphone%20with%20warning%20mark%2C%20muted%20teal%20and%20cream%20paper%20tones%2C%20minimal%20geometric%20shapes%2C%20subtle%20texture%2C%20no%20text&width=1200&height=800&seq=ev-cover-03&orientation=landscape",
    tags: ["营销话术", "绝对化用语", "核查中"],
    summary:
      "观众反馈该直播间在推广食品时多次使用绝对化、承诺性表述，且对成分与功效的描述与实际商品页面信息不一致。平台已受理并进入核查阶段。",
    focus: [
      "营销话术是否构成虚假或误导性描述",
      "口播内容与商品页面信息是否一致",
      "同类话术是否在往期直播中重复出现",
    ],
    timeline: [
      {
        time: "08-12 21:05",
        title: "收到观众线索反馈",
        desc: "156 条反馈集中在同一场直播的营销环节。",
      },
      {
        time: "08-13 10:40",
        title: "平台受理并进入核查",
        desc: "调取该场回放，比对口播内容与商品详情页。",
      },
      {
        time: "08-27 16:10",
        title: "要求补充说明材料",
        desc: "平台向商家发出核查问询，等待成分说明与话术脚本。",
      },
    ],
    resultType: "核查进行中",
    result:
      "本事件目前已受理并进入核查阶段，平台已完成回放比对并发出核查问询。处理结果将在核查结束后第一时间同步给提交线索的用户，并进入处理结果公示区。举报人可凭受理编号查询进度。",
    related: ["ev-2026-0806-04", "ev-2026-0730-06"],
  },
  {
    id: "ev-2026-0806-04",
    title: "带货直播“潮玩拆盒专线”抽奖规则与公示不符",
    category: "消费纠纷",
    status: "已处理",
    date: "2026-08-06",
    updatedAt: "2026-08-15",
    platform: "晨光直播",
    room: "潮玩拆盒专线",
    reports: 271,
    views: 15420,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20gift%20box%20and%20numbered%20tags%2C%20warm%20gold%20and%20cream%20paper%20tones%2C%20minimal%20geometric%20composition%2C%20no%20text&width=1200&height=800&seq=ev-cover-04&orientation=landscape",
    tags: ["抽奖争议", "规则不一致", "打赏纠纷"],
    summary:
      "直播间宣传的抽奖规则与直播间顶部公示的规则存在明显差异，部分完成打赏的用户未获得承诺的抽奖次数。多名用户提交消费争议投诉并附上打赏记录。",
    focus: [
      "口播规则与公示规则不一致时以哪一份为准",
      "已打赏用户的抽奖次数如何补足",
      "是否属于误导性营销",
    ],
    timeline: [
      {
        time: "08-06 20:50",
        title: "用户集中反馈规则不一致",
        desc: "271 条投诉，普遍附有打赏记录截图与公示规则截图。",
      },
      {
        time: "08-07 11:30",
        title: "平台受理并核对两版规则",
        desc: "确认口播版本与公示版本存在三处关键差异。",
      },
      {
        time: "08-11 09:00",
        title: "组织双方说明",
        desc: "商家承认话术与公示规则未同步更新。",
      },
      {
        time: "08-15 17:30",
        title: "核查结束并公示",
        desc: "要求补足抽奖次数并退还差额。",
      },
    ],
    resultType: "退还差额并整改",
    result:
      "核查认定直播口播规则与公示规则不一致，导致部分用户权益受损。平台要求商家在 7 个工作日内为受影响用户补足抽奖次数，并对无法补足的部分退还对应差额；同时要求抽奖规则以公示版本为准，整改期内不得开展同类抽奖活动。",
    related: ["ev-2026-0819-02", "ev-2026-0812-03"],
  },
  {
    id: "ev-2026-0730-05",
    title: "电竞联赛直播间赛事高峰段长时间掉线",
    category: "画面中断",
    status: "受理中",
    date: "2026-07-30",
    updatedAt: "2026-08-01",
    platform: "巅峰赛事",
    room: "夏季联赛半决赛",
    reports: 486,
    views: 21340,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20stadium%20screen%20going%20dark%2C%20deep%20teal%20and%20cream%20paper%20tones%2C%20minimal%20geometric%20waves%2C%20subtle%20texture%2C%20no%20text&width=1200&height=800&seq=ev-cover-05&orientation=landscape",
    tags: ["赛事中断", "高峰掉线", "受理中"],
    summary:
      "半决赛决胜局进行中，直播间出现长时间掉线，恢复后已错过关键赛点。该场次观看人数较高，观众反馈集中于中断期间无任何状态说明。平台已受理，正在核查中断原因与通知机制。",
    focus: [
      "掉线原因是否属于可预见的技术风险",
      "中断期间为何缺少状态提示",
      "错过赛点的观众权益如何补偿",
    ],
    timeline: [
      {
        time: "07-30 19:42",
        title: "决胜局期间掉线",
        desc: "直播画面冻结后黑屏，持续约 9 分钟。",
      },
      {
        time: "07-30 19:51",
        title: "恢复后错过关键赛点",
        desc: "观众反馈集中，互动区大量表达不满。",
      },
      {
        time: "08-01 10:20",
        title: "平台受理",
        desc: "共收到 486 条反馈，已向赛事方调取技术日志。",
      },
    ],
    resultType: "受理中",
    result:
      "本事件已受理，平台正在核查中断期间的技术日志与通知机制。核查期间，赛事方需在下一场开播前提交状态提示方案。处理结果将在核查完成后同步并公示。",
    related: ["ev-2026-0824-01", "ev-2026-0819-02"],
  },
  {
    id: "ev-2026-0721-06",
    title: "音乐翻唱直播未标注原唱与授权信息",
    category: "版权争议",
    status: "已处理",
    date: "2026-07-21",
    updatedAt: "2026-07-28",
    platform: "声浪直播",
    room: "夜半翻唱电台",
    reports: 96,
    views: 6380,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20music%20notes%20and%20a%20copyright%20mark%2C%20muted%20vermilion%20and%20cream%20paper%20tones%2C%20minimal%20geometric%20shapes%2C%20no%20text&width=1200&height=800&seq=ev-cover-06&orientation=landscape",
    tags: ["翻唱授权", "署名缺失", "版权争议"],
    summary:
      "权利人反映该直播间长期进行商业性翻唱，既未标注原唱与词曲作者，也未提供授权信息。平台受理后组织核查，要求直播间补充署名与授权说明。",
    focus: [
      "商业性翻唱是否需要取得授权",
      "未标注原唱与词曲作者是否构成侵权",
      "往期回放如何处理",
    ],
    timeline: [
      {
        time: "07-21 15:20",
        title: "权利人提交投诉",
        desc: "附权属说明与三场直播的回放时间点。",
      },
      {
        time: "07-22 11:00",
        title: "平台受理并比对回放",
        desc: "确认存在未署名翻唱与商业性使用情形。",
      },
      {
        time: "07-25 14:30",
        title: "组织补充授权说明",
        desc: "直播间提交部分曲目的授权凭证。",
      },
      {
        time: "07-28 18:00",
        title: "核查结束并公示",
        desc: "未获授权曲目下架并补充署名规范。",
      },
    ],
    resultType: "下架并规范署名",
    result:
      "核查认定部分曲目未取得授权即用于商业性翻唱，且未标注原唱与词曲作者。处理结果为下架未获授权的翻唱回放，要求直播间在后续开播中完整标注原唱与词曲作者信息，并建立曲目授权台账以备核查。",
    related: ["ev-2026-0812-03", "ev-2026-0819-02"],
  },
];